<mat-toolbar color="primary" class='mat-elevation-z8 shadow' >
    <span class="gap icons"><a [routerLink]="['/']"><img src="{{ companyLogo }}" height="30px" ></a></span>
    <!-- <span class="gap icons"><a href="{{ facebook }}"><img class="mat-elevation-z4 rad" src="assets/images/facebook.webp" width="25px;"/></a></span>
    <span class="gap icons"><a href="{{ linkedin }}"><img class="mat-elevation-z4 rad" src="assets/images/linkedin.webp" width="25px;"/></a></span> -->
    <span class="middle"></span>
    <span class="copyright"><mat-icon color="accent" style="color: white; vertical-align: middle;">copyright</mat-icon>{{ copyright }}</span>
</mat-toolbar>
